// extracted by mini-css-extract-plugin
export default {"nameCell":"DivisionNameCell_nameCell__G3U5h","nameIcon":"DivisionNameCell_nameIcon__tYcV4"};